import React, {ReactNode, useState} from 'react';
import {Input, Modal} from "@tag/tag-components-react-v4";
import {OrganisationDTO} from "../../../types/OrganisationDTO";
import { ProjectAccents } from "../../../../General/config/projectAccents";

function DeletionConfirmationModal(props: { visible: boolean, isUserAllowed: boolean, selectedOrganisation: OrganisationDTO, modalMessage: ReactNode, handleClose: Function, handleDeletion: Function }) {
    
    const [reason, setReason] = useState('');
    
    if (!props.isUserAllowed) {
        throw new Error()
    }

    const renderModalContent = () => {
        let modalContent;
        

        modalContent = (
            <>
                {props.modalMessage}
                <Input
                    placeholder="Enter Salesforce ID or reason to confirm"
                    clearButton
                    style={{width: '200px'}}
                    onChange={(e) => setReason(e.currentTarget.value)}
                />
            </>
        )

        return modalContent;
    }

    let content;
    content = <>
        <Modal
            visible={props.visible}
            accent={ProjectAccents.PoliciesAndProcedures}
            heading={'Confirm'}
            onCancelButtonClick={() => {
                props.handleClose();
            }}
            onClose={() => props.handleClose()}
            primaryButtonProps={{text: 'Confirm', disabled: !reason}}
            onPrimaryButtonClick={() => props.handleDeletion(reason)}
        >
            <div>
                {renderModalContent()}
            </div>
        </Modal>
    </>

    return (
        <>
            {content}
        </>
    )

}

export default DeletionConfirmationModal;
